export const hasNotch = () => false;
export const isEmulator = () => false;
export const getVersion = () => 'unknown';
export const getBundleId = () => 'unknown';
export const getDeviceType = () => 'unknown';
export const hasDynamicIsland = () => false;
export const getUniqueId = () => 'unknown';
